import styles from "./wizard.module.scss";
import { Typography, Paper, Step, Stepper, StepButton, StepContent } from "@mui/material";
import { memo, useEffect, useState } from "react";
import IndividualStep from "./components/Step";
import { useAppDispatch, useAppSelector} from "store/hooks";
import { handleSetSelection, handleToggleCheckout, setYears } from "store/wizard";
import { options } from "services/options";
import { red } from "@mui/material/colors";

const Individual = (props:any) => {
  
  const [notify, setNotify] = useState(false);
  const [missingSteps, setMissingSteps] = useState<number[]>([0,1,2,3,4,5,6]);
  const [activeStep, setActiveStep] = useState(0);
  const dispatch = useAppDispatch();
  const { selection } = useAppSelector((state) => state.wizard);

  
  useEffect(() => {
    // Restore wizard
    const data = sessionStorage.getItem("cb_checkout_S");
    const years = sessionStorage.getItem("cb_checkout_Y");
    
    if(data && years) {
      const parsedData = JSON.parse(data);
      dispatch(setYears(parseInt(years)));
      for (let key in parsedData) {
        setTimeout(() => {
          dispatch(handleSetSelection({
            selection: parsedData[key],
            step: parseInt(key)
          }));
        }, 0);
      }
    }
    
  },[dispatch]);
  
  useEffect(() => {
    const newMissingSteps:number[] = [];
    for (let i = 0; i <= 6; i++) {
      if (!(i in selection)) {
        newMissingSteps.push(i);
      }
    }
    setMissingSteps(newMissingSteps);
  },[selection]);

  const handleStep = (step:number) => {
    setActiveStep(step);
  }
  
  const onSubmitCallback = (step) => {
    if(step === 7) {
      if(missingSteps.length > 0) {
        setNotify(true);
      } else {
        dispatch(handleToggleCheckout(true));
      }
      return;
    };
    const nextStep = step + 1;
    setActiveStep(nextStep);
  }

  const onBackCallback = () => {
    const prevStep = activeStep - 1;
    setActiveStep(prevStep);
  }

  const displayLabel = (step) => {
    if(step === 1 || step === 2) {
      if(missingSteps.includes(step) && notify) {
        return <Typography variant="caption" color={red[500]}>Please complete this step</Typography>;
      }

      if(selection[step] || selection[step] === 0 || activeStep === step) {
        return (
          <Typography variant="caption" color="#555">
            {
              options[step]["list"][0]["label"]
            } {
              (selection[step] || selection[step] === 0) && " (" + selection[step]/options[step]["list"][0]["weight"] + " times)"
            }
          </Typography>
        )
      } else {
        return null;
      }
      
    }
    if(selection[step]) {
      return <Typography variant="caption" color="#555">
        {options[step]["list"][selection[step] - 1]?.label}
      </Typography>
    } else if(missingSteps.includes(step) && notify) {
      return <Typography variant="caption" color={red[500]}>Please complete this step</Typography>
    }
  }

  return (
    <>
      <Paper className={`${styles.wizardWrapper}`} elevation={3}>
        <div className="row justify-content-center">
          <div className="col-md-11 col-12">
            <Typography variant="h4" align="center" color="primary">
              Unlock Your Personal Carbon Footprint: Answer a Few Simple Questions and Contribute to a Greener World by Planting Trees!
            </Typography>
          </div>
        </div>
        <Stepper activeStep={activeStep} orientation="vertical" nonLinear={true}>
          {
            Object.keys(options).map((key) => {
              const i = parseInt(key);
              return (
                <Step key={key}>
                  <StepButton
                    onClick={() => handleStep(i)}
                    optional={displayLabel(i)}
                  >
                    <Typography variant="body1">{options[i]["title"]}</Typography>
                  </StepButton>
                  <StepContent>
                    <IndividualStep 
                      submitCallback={(step) => onSubmitCallback(step)}
                      options={options[i]["list"]}
                      label={options[i]["question"]}
                      backCallback={() => onBackCallback()}
                      step={i}
                    />
                  </StepContent>
                </Step>
              )
            })
          }
        </Stepper>
      </Paper>
    </>
  );
};
export default memo(Individual);
